import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import CustomerForm from "../../components/Customers/CustomerForm";

const CustomersEdit = ({classes, customer, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('boards.edit_board')}
        />

        <Card>
            <CardContent>
                <CustomerForm
                    values={customer}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default CustomersEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/customers/Edit.jsx